import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {useTheme} from 'react-jss';
import Language from '../../../v2/lang/language';
import Translation from '../../../v2/lang/Translation';
import isUsingArtemisStyles from '../../../v2/selectors/isUsingArtemisStyles';
import {getSiteCode} from '../../../v2/selectors/selectors';
import useStyles from './CompletePageInformation.styles';

export function CompletePageInformationPresentational(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  const additionalSiteSpecificInformationHeaderKey = `checkout.complete.help.heading.site.specific.${props.siteCode}.text`;
  const additionalSiteSpecificInformationParagraphKey = `checkout.complete.help.paragraph.site.specific.${props.siteCode}.text`;
  
  const doSiteSpecificKeysExist = Language.doTranslationsExist([
    additionalSiteSpecificInformationHeaderKey,
    additionalSiteSpecificInformationParagraphKey,
  ]);
  
  return (
    <div className={classes.informationContainer} data-test="CompletePageInformation">
      <h2 className={classes.header}><Translation>checkout.complete.help.heading.text</Translation></h2>
      <div className={classes.information}>
        <div className={classes.block}>
          <h3 className={classes.subheader}><Translation optionalExtension={props.siteCode}>checkout.complete.help.heading1.text</Translation></h3>
          <p>
            <Translation optionalExtension={props.siteCode}>checkout.complete.help.paragraph1.text</Translation>
          </p>
          <h3 className={classes.subheader}><Translation optionalExtension={props.siteCode}>checkout.complete.help.heading2.text</Translation></h3>
          <p>
            <Translation optionalExtension={props.siteCode}>checkout.complete.help.paragraph2.text</Translation>
          </p>
        </div>
        <div className={classes.block}>
          <h3 className={classes.subheader}><Translation optionalExtension={props.siteCode}>checkout.complete.help.heading3.text</Translation></h3>
          <p>
            <Translation optionalExtension={props.siteCode}>checkout.complete.help.paragraph3.text</Translation>
          </p>
          <h3 className={classes.subheader}><Translation optionalExtension={props.siteCode}>checkout.complete.help.heading4.text</Translation></h3>
          <p>
            <Translation optionalExtension={props.siteCode}>checkout.complete.help.paragraph4.text</Translation>
          </p>
          <h3 className={classes.subheader}><Translation optionalExtension={props.siteCode}>checkout.complete.help.heading5.text</Translation></h3>
          <p>
            <Translation optionalExtension={props.siteCode}>checkout.complete.help.paragraph5.text</Translation>
          </p>
          
          {doSiteSpecificKeysExist && (
            <div data-test="CompletePageInformation__siteSpecificSection">
              <h3 className={classes.subheader}>
                <Translation>{additionalSiteSpecificInformationHeaderKey}</Translation>
              </h3>
              <p><Translation>{additionalSiteSpecificInformationParagraphKey}</Translation></p>
            </div>
          )}
        
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = state => ({
  siteCode: getSiteCode(state),
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

CompletePageInformationPresentational.propTypes = {
  siteCode: PropTypes.string.isRequired,
  isUsingArtemisStyles: PropTypes.bool,
};

export default connect(mapStateToProps)(CompletePageInformationPresentational);
